import moment from "moment";
import { InvoiceDTO } from "../models/InvoiceDTO";

export const GetLabels = (invoice: InvoiceDTO) => {

  const hasDateProformaScrapped = invoice.dateProformaScrapped !== null

  const invoiceType = {
    Invoice: {
      header: invoice.hasBillingSite
        ? "Vat Invoice"
        : "Invoice", 
      subHeader: "",
      label: "Invoice no.",
      dateLabel: invoice.hasBillingSite
        ? "Invoice/Tax date" 
        : "Invoice date", 
      paymentDateLabel: "Due date"
    },
    ProForma: {
      header: hasDateProformaScrapped
        ? `Pro-Forma Invoice - Scrapped on ${moment(invoice.dateProformaScrapped).format('Do MMM YYYY')}` 
        : "Pro-Forma Invoice", 
      subHeader: "THIS IS NOT A TAX INVOICE",
      label: "Pro-Forma no.",
      dateLabel: "Date of issue",
      paymentDateLabel: "Payment due date"
    },
    Credit: {
      header: "Credit Note",
      subHeader: "",
      label: "Credit note no.",
      dateLabel: "Credit note date",
      paymentDateLabel: ""
    }
  };

  return Object.values(invoiceType)[Object.keys(invoiceType).indexOf(invoice.type.toString())];
}
